import e from"styled-components";const t=e.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	row-gap: 24px;
`,i=e.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	max-width: 100%;
`,o=e.div`
	position: relative;
`,n=e.span`
	position: absolute;
	font-size: 40px;
	bottom: 0;
	right: -10px;
`,l=e.img`
	width: ${({isTemplate:e})=>e?"60px":"80px"};
	height: ${({isTemplate:e})=>e?"60px":"80px"};
	border-radius: 50%;
	object-fit: cover;
	object-position: center;
	margin-bottom: 8px;
`,p=e.h1`
	all: unset;
	color: ${({theme:e})=>e.text.input};
	text-align: center;
	font-size: ${({isTemplate:e})=>e?"14px":"20px"};

	font-style: normal;
	font-weight: 500;
	line-height: ${({isTemplate:e})=>e?"16px":"25.887px"};

	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
	max-width: 100%;
`,r=e.h2`
	all: unset;
	color: ${({color:e})=>e};
	text-align: center;
	font-size: ${({isTemplate:e})=>e?"10px":"14px"};

	font-style: normal;
	font-weight: 500;
	line-height: ${({isTemplate:e})=>e?"12px":"19px"};
`,s=e.div`
	border-radius: 100px;
	background: ${({backgroundColor:e,theme:t})=>e||t.border.black10};
	display: flex;
	padding: ${({isTemplate:e})=>e?" 3.699px 7.399px":"5px 10px"};

	justify-content: center;
	align-items: center;

	color: ${({color:e,theme:t})=>e||t.text.title};
	font-size: ${({isTemplate:e})=>e?"9px":"12px"};

	font-style: normal;
	font-weight: 500;
	line-height: ${({isTemplate:e})=>e?"9px":"16px"};
`;export{t as CardContent,i as CardDetails,s as Label,l as PeopleAvatar,o as PeopleAvatarContainer,n as PeopleAvatarEmoji,p as PeopleName,r as PeopleSubtitle};
